import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
///
/// This state displays flowmodels that the user can initiaite
///

angular.module('flowingly.runner.flows.active').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.flowsactive, {
    url: 'flowsactive/',
    params: { title: 'Start Flows', backFromState: '' },
    controller: [
      '$stateParams',
      function ($stateParams) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const $ctrl = this;
        $ctrl.backFromState = $stateParams.backFromState;
      }
    ],
    controllerAs: '$ctrl',
    template:
      '<flows-active back-from-state="$ctrl.backFromState"></flows-active>'
  });
}
